<template>
  <TsCard footer-class="mt-auto" append-class="flex flex-col p-0 bg-white h-full" dataTestid="blogs-news-and-advice-card"
    :no-border="noBorder" :no-shadow="noShadow">
    <template #header>
      <NuxtLinkWithLocale :to="data?.url">
        <div class="h-[226px] overflow-hidden">
          <TsImage
            :src="`${data?.adviceImage}?format=webp`"
            :alt="data?.title"
            title=""
            class="mb-0 h-full bg-no-repeat bg-transparent border-none rounded-b-none"
            width="403"
            height="598"
            dataTestid="blogs-news-and-advice-banner-advice-img"
            loading="lazy"
          />
        </div>
      </NuxtLinkWithLocale>
    </template>
    <template #content>
      <TsRow class="mb-2 m-0 gap-2 px-4 justify-between">
        <TsTag append-class="bg-info/10 cursor-pointer" rounded @click="
          builderStore.redirectToAdvicesWithCategory(
            data?.categories?.value?.data?.slug
          )
          " dataTestid="blogs-news-and-advice-banner-advice-category-tag">
          <TsTypography append-class="mb-0" dataTestid="blogs-news-and-advice-category-name-advice">{{
            data?.categories?.value?.data?.name }}</TsTypography>
        </TsTag>
        <TsTypography size="sm" append-class="mb-0 flex items-center"
          dataTestid="blogs-news-and-advice-news-typography-hours">
          {{ formatDate(props.date) }}
        </TsTypography>
      </TsRow>
      <NuxtLinkWithLocale :to="data?.url">
        <TsTypography append-class="!mb-0 min-h-12 line-clamp-2 px-4 text-idle-black" dataTestid="blogs-news-and-advice-title-advice-typo"
          weight="bold">{{ data?.title }}
        </TsTypography>
      </NuxtLinkWithLocale>
      <TsTypography append-class="mb-2 px-4" as="p" dataTestid="blogs-news-and-advice-excerpt-advice-typo">{{ data?.excerpt
        }}</TsTypography>
    </template>
    <template #footer v-if="!hideReadMore">
      <NuxtLinkWithLocale :to="data?.url">
        <TsTypography weight="bold" append-class="p-4 underline mb-0 underline-offset-2 cursor-pointer text-info"
          dataTestid="blogs-news-and-advice-read-more-typo">
          {{ useTranslation('readMore', 'Lees meer') }}
        </TsTypography>
      </NuxtLinkWithLocale>
    </template>
  </TsCard>
</template>

<script setup lang="ts">
import { useTranslation } from "~/composables/useTranslation";
import { formatDate } from "~/utils/formatDateAndTime";

const TsCard = defineAsyncComponent(
  () => import('~/components/organisms/TsCard.vue')
);

const builderStore = useBuilderStore();

type Data = {
  id: number;
  title: string;
  excerpt: string;
  url: string;
  adviceImage: string;
};

type Props = {
  dataTestid: string;
  data: Data;
  noBorder?: boolean;
  noShadow?: boolean;
  hideReadMore?: boolean;
  date: string;
};

const props = withDefaults(defineProps<Props>(), {});
</script>
